import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/solid';
import { Link, useLocation } from 'react-router';

export default function Breadcrumbs() {
  const location = useLocation();
  const locationArray = location.pathname.split('/');
  locationArray.splice(0, 2);

  const pages: { name: string; label: string; path: string }[] = [];

  let pathConstruct = '/app';
  locationArray.forEach((loc, index) => {
    pathConstruct += `/${loc}`;
    // Rover shows a form's applications as "Submissions"; the URL segments stay `applications` / `application_details`.
    const isRoverSubmissions =
      loc === 'applications' && locationArray[index - 2] === 'application_forms' && locationArray.includes('rover');
    const isRoverSubmissionDetails =
      loc === 'application_details' && locationArray[index - 2] === 'applications' && locationArray[index - 4] === 'application_forms';
    const label = isRoverSubmissions ? 'submissions' : isRoverSubmissionDetails ? 'submission_details' : loc;
    pages.push({ name: loc, label, path: pathConstruct });
  });

  return (
    <nav className='flex' aria-label='Breadcrumb'>
      <ol className='flex items-center space-x-1'>
        <li>
          <div>
            <Link to='/terminal/dashboard' className='text-gray-400 hover:text-gray-500'>
              <HomeIcon className='shrink-0 h-4 w-4' aria-hidden='true' />
              <span className='sr-only'>Home</span>
            </Link>
          </div>
        </li>
        {pages.map((page, index) => (
          <li key={page.name}>
            <div className='flex items-center'>
              <ChevronRightIcon className='shrink-0 h-4 w-4 text-gray-400' aria-hidden='true' />
              <Link
                to={page.name === 'document' || page.name === 'invoice' ? pages[index - 1]?.path : page.path}
                className='ml-1 text-xs font-medium text-gray-500 hover:text-gray-700 capitalize'
              >
                {page.label}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
